(function() {

	"use strict"

	angular.module( "ATMGurus" )

	.directive( "breadcrumbs", [
		"Navigation",
		"$stateParams",
		"$state",
		"$rootScope",
		function( Navigation, $stateParams, $stateProvider, $rootScope ) {
			return {
				restrict: "A",
				replace: true,
				scope: {
					parents: "&",
					current: "&"
				},
				template: "<div><h1 class='page-heading h4 text-upper'>{{ root }}</h1><span class='breadcrumb-item breadcrumb-current'>{{ current }}</span></div>",
				link: function(scope, element, attrs) {

					var parents = scope.parents();

					if ( angular.isDefined( attrs.current ) ) {
						if ( scope.current() && typeof scope.current().catch  === 'function' ) {
							scope.current()
								.then( function( response ) {
									scope.current = response;
								})
						}
						else {
							scope.current = scope.current()
						}
					}
					else {
						scope.current = Navigation.getCurrentPageTitle();
					}
					var root = "";

					if ( parents ) {
						scope.root = parents[0]
					}
					else {
						scope.root = $stateParams.page || $stateProvider.current.name;
					}
				}
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/directives/breadcrumbs.js